import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { WebapiService } from 'src/app/shared/services/webapi.service';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { Store, select } from '@ngrx/store';
import { getUserInfo } from 'src/app/store/selector/selector';
import { AppState } from 'src/app/store/app.states';
import { take } from 'rxjs/operators';
declare var bootstrap;
declare var $: any;
@Component({
  selector: 'app-new-videos',
  templateUrl: './new-videos.component.html',
  styleUrls: ['./new-videos.component.scss']
})
export class NewVideosComponent implements OnInit, AfterViewInit {
  user:any
  videoDetails: any;
  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: false,
    touchDrag: false,
    pullDrag: false,
    dots: true,
    autoWidth: true,
    navSpeed: 700,
    navText: [ '<i class="fas fa-chevron-left"></i>', '<i class="fas fa-chevron-right"></i>' ],
    responsive: {
      0: {
        items: 1
      },
      400: {
        items: 1
      },
      740: {
        items: 2
      },
      940: {
        items: 3
      }
    },
    nav: true
  }

  constructor(public webApi: WebapiService,private store: Store<AppState>, private toastrService: ToastrService) {
  }

  
  openDetails(id: Number,modalid:any){
    this.videoDetails = '';
    this.videoDetails = this.webApi.newVideos.filter(function(video:any) {
      return video.id == id;
    })[0]; 
    
    if(this.videoDetails.allowed==0){
      setTimeout(()=>{
        if(document.getElementById('videos-locked-popup-modal')){
          var myModal = new bootstrap.Modal(document.getElementById('videos-locked-popup-modal'), {
            keyboard: true
          })
          myModal.show()
          //console.log('show-new-vids modal')
        }
      },300)
      return 
    }

    setTimeout(function(){
      $('#'+modalid).modal('show');
    }, 100);
  }

  ngOnInit()  
  {    
    setTimeout(()=>{
      this.getUserData()
    },1000)
  } 

  ngAfterViewInit(): void {
    setTimeout(()=>{
      window.dispatchEvent(new Event('resize'));
    },1000)
 }
  
  getThumbUrl(url : string){
    return  "assets/images/"+url
  }

  
  getUserData(){

    this.webApi.setLoader(true)

    this.store.pipe(select(getUserInfo),take(1)).subscribe(data=>{
      this.user = data
      this.webApi.setLoader(false)
    },error=>{
      this.webApi.setLoader(false)
      this.toastrService.error("unable to handle response");
    })
    // this.webApi.getUserData().subscribe((data: any) => {
    //   if(data.success){
    //     this.user=data.data
    //   }else{
    //     this.toastrService.error(data.message);
    //   }
    // },
    // error => {
    //   this.toastrService.error("unable to handle response");
    // });
  }
  
}
